export default __webpack_public_path__ + "static/media/Prosciutto.2820b5a7.jpg";